import { render } from "./NewVoyageType.vue?vue&type=template&id=21c1692d"
import script from "./NewVoyageType.vue?vue&type=script&lang=js"
export * from "./NewVoyageType.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__